import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["code"]

  download(event) {
    event.preventDefault()

    const codes = this.codeTargets.map(target => target.textContent.trim()).join("\n")
    const blob = new Blob([codes], { type: "text/plain" })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = "mijngrond_backup_codes.txt"
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
  }
}
